import PropTypes from 'prop-types';
import React from 'react';
import { Route } from 'react-router-dom';

const RouteWithLayout = props => {
    const { layout: Layout, component: Component, rules, ...rest } = props;

    return (
        <Route
            {...rest}
            render={matchProps => (
                <Layout {...props.props} rules={rules}>
                    <Component {...matchProps} />
                </Layout>
            )}
        />
    );
};

RouteWithLayout.propTypes = {
    component: PropTypes.any.isRequired,
    layout: PropTypes.any.isRequired,
    path: PropTypes.string
};

export default RouteWithLayout;
